<section class="container">
  <div class="page-header-container">
    <div class="page-title-container">
      <button class="back_icon me-2" mat-icon-button (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 class="page-title" translate>All Submissions</h1>
    </div>
  </div>

  <div class="submission_container bg-white">
    <!-- Header Info -->
    <div class="header-info">
      <span>Reg: {{ data.headerInfo.reg }}</span>
      <span>{{ data.headerInfo.course }}</span>
      <span>{{ data.headerInfo.semester }}</span>
      <span>M: {{ data.headerInfo.subject }}</span>
      <span>Sec: {{ data.headerInfo.section }}</span>
      <span>Deadline: {{ data.headerInfo.deadline }}</span>
    </div>

    <mat-divider></mat-divider>

    <!-- Summary Cards -->
    <div class="summary-cards p-3">
      <mat-card class="summary-card" *ngFor="let key of statKeys">
        <div class="summary-content">
          <div class="label">{{ key | titlecase }}</div>
          <div
            class="value"
            [ngClass]="{
              success: key === 'submitted',
              pending: key === 'pending',
              late: key === 'lateSubmission'
            }"
          >
            {{ data.stats[key] }}
          </div>
        </div>
      </mat-card>
    </div>

    <mat-divider></mat-divider>

    <!-- Submissions Table -->
    <div class="table-container mat-elevation-z2">
      <table mat-table [dataSource]="data.submissions" class="full-width-table">
        <ng-container matColumnDef="studentName">
          <th mat-header-cell *matHeaderCellDef translate>Student Name</th>
          <td mat-cell *matCellDef="let el">{{ el.studentName }}</td>
        </ng-container>

        <ng-container matColumnDef="rollNumber">
          <th mat-header-cell *matHeaderCellDef translate>Roll Number</th>
          <td mat-cell *matCellDef="let el">{{ el.rollNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef translate>Status</th>
          <td mat-cell *matCellDef="let el">
            <span class="status" [ngClass]="el.status.toLowerCase()">{{
              el.status
            }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="submittedOn">
          <th mat-header-cell *matHeaderCellDef translate>Submitted On</th>
          <td mat-cell *matCellDef="let el">{{ el.submittedOn }}</td>
        </ng-container>

        <ng-container matColumnDef="marks">
          <th mat-header-cell *matHeaderCellDef translate>Marks</th>
          <td mat-cell *matCellDef="let el">{{ el.marks ?? "-" }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef translate>Actions</th>
          <td mat-cell *matCellDef="let element">
            <button
              mat-icon-button
              [matMenuTriggerFor]="actionrequest"
              aria-label="Actions"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>

            <mat-menu #actionrequest="matMenu">
              <button mat-menu-item (click)="onView(element)">
                <i class="fa-solid fa-eye me-2"></i><span translate>View</span>
              </button>
              <!-- <button mat-menu-item (click)="editAssignment(element)">
              <i class="fa-solid fa-pen-to-square me-2"></i> Edit
            </button> -->
              <!-- <button mat-menu-item (click)="deleteAssignment(element)">
              <i class="fa-solid fa-trash me-2"></i> Delete
            </button> -->
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</section>
